<template>
  <b-modal :active.sync="isActive" has-modal-card :can-cancel="false">
    <div class="modal-card" style="width: 700px; max-width: 90vw;">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Data Manipulation Guide
        </h1>
      </header>
      <section class="modal-card-body enable-select-text">
        <div class="guide-content">
          <div class="guide-section">
            <h4 class="section-title">1. Concatenate Multiple Fields</h4>
            <p class="section-description">Combine fields of similar types:</p>
            <ul class="guide-list">
              <li>
                <strong>String concatenation:</strong><br />
                <code class="formula-code"
                  >=[Product Name]+"_"+[Pack Description]</code
                >
              </li>
              <li>
                <strong>Number concatenation/sum:</strong><br />
                <code class="formula-code"
                  >=[Pack Size] + [Double Pack Size]</code
                >
              </li>
            </ul>
          </div>

          <div class="guide-section">
            <h4 class="section-title">2. Convert to Double</h4>
            <p class="section-description">
              Convert string numbers with leading zeros to double:
            </p>
            <code class="formula-code">=CDbl([Pack Size])</code>
          </div>

          <div class="guide-section">
            <h4 class="section-title">3. IF Condition</h4>
            <p class="section-description">
              Example: If Supplier is "IEE002" or "IEF010" then "Yes", otherwise
              "No":
            </p>
            <code class="formula-code break-word"
              >=IF([Supplier Code]="IEE002","Yes",IF([Supplier
              Code]="IEF010","Yes","No"))</code
            >
          </div>

          <div class="guide-section">
            <h4 class="section-title">4. Trim String Value</h4>
            <p class="section-description">
              Extract LEFT 6 characters from a string:
            </p>
            <code class="formula-code">=LEFT([Supplier Name],6)</code>
          </div>

          <div class="guide-section">
            <h4 class="section-title">5. Additional Functions</h4>
            <p class="section-description">You can also use:</p>
            <ul class="guide-list">
              <li><strong>ROUND</strong> - for rounding number fields</li>
              <li><strong>IsNull</strong> - for logical null checks</li>
            </ul>
          </div>

          <div class="guide-section">
            <h4 class="section-title">6. Add Hard-coded Value</h4>
            <p class="section-description">
              Add a constant value to a new column (e.g., "Put on Market
              Country"):
            </p>
            <code class="formula-code">="UK"</code>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button type="is-primary" @click="close">Close</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DataManipulationGuide",
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.guide-content {
  text-align: left;
  line-height: 1.8;
}

.guide-title {
  margin-bottom: 15px;
  color: #2babe2;
  font-size: 1.25rem;
  font-weight: 600;
}

.guide-section {
  margin-top: 20px;
}

.section-title {
  margin-bottom: 10px;
  color: #363636;
  font-size: 1rem;
  font-weight: 600;
}

.section-description {
  margin-bottom: 8px;
  color: #4a4a4a;
}

.guide-list {
  margin-left: 20px;
  margin-bottom: 15px;
}

.guide-list li {
  margin-top: 10px;
}

.guide-list li:first-child {
  margin-top: 0;
}

.formula-code {
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 5px;
  font-family: monospace;
  font-size: 0.9rem;
  color: #363636;
}

.break-word {
  word-break: break-all;
  max-width: 100%;
}
</style>
